// src/utils/savePDF.js
// Сохранение Blob как PDF на устройстве.
// На Android (Capacitor) — через Filesystem в папку Documents
// На вебе — через download link

import { Capacitor } from '@capacitor/core';

async function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const dataUrl = reader.result;
      // Убираем "data:application/pdf;base64,"
      const base64 = dataUrl.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function savePDF(blob, filename) {
  if (Capacitor.isNativePlatform()) {
    // Android — сохраняем в Documents
    const { Filesystem, Directory } = await import('@capacitor/filesystem');
    const base64 = await blobToBase64(blob);

    const result = await Filesystem.writeFile({
      path: filename,
      data: base64,
      directory: Directory.Documents,
      recursive: true,
    });

    return { uri: result.uri, native: true };
  } else {
    // Веб — обычное скачивание
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return { uri: filename, native: false };
  }
}
